import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));


// declare const grecaptcha: any;

// import { enableProdMode } from '@angular/core';
// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// import { AppModule } from './app/app.module';
// import { environment } from './environments/environment';

// // const USE_MOCK_ACCESS_API = false; // TEMPORARY FLAG

// if (environment.production) {
//   enableProdMode();
// }

// /**
//  * Bootstraps Angular
//  */
// function bootstrapAngularApp(): void {
//   platformBrowserDynamic()
//     .bootstrapModule(AppModule)
//     .catch(err => console.error(err));
// }

// /**
//  * Access denied UI
//  */
// /**
//  * Shows an Access Denied screen
//  */
// function renderAccessDenied(): void {
//   document.body.innerHTML = `
//     <div style="
//       display: flex;
//       height: 100vh;
//       align-items: center;
//       justify-content: center;
//       font-family: Arial, sans-serif;
//       background: #f5f5f5;
//     ">
//       <div style="text-align: center;">
//         <h1>Access Denied</h1>
//         <p>Automated access to this service is restricted.</p>
//         <p>If you believe this is an error, please contact support at <a style="color: #3B6FB6; border-bottom: none;" href="mailto:afdbhelp@ebi.ac.uk">alphafolddb&#64;ebi.ac.uk</a></p>
//       </div>
//     </div>
//   `;
// }

// /**
//  * Real API verification (future)
//  */
// async function realVerifyAccess(token: string) {
//   const auth = environment.apiKey ? `?key=${environment.apiKey}` : '';
//   const verfyurl = environment.verifyUrl + auth;
//   const res = await fetch(
//     verfyurl,
//     {
//       method: 'POST',
//       headers: {
//         'accept': 'application/json',
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({
//         token: token,
//         recaptcha_action: 'LOGIN',
//       }),
//     }
//   );
//   const response = res.json();
//   return response;
// }

// function waitForGrecaptcha(timeout = 3000): Promise<void> {
//   return new Promise((resolve, reject) => {
//     const start = Date.now();

//     const check = () => {
//       // Check if grecaptcha and the enterprise property exist
//       if (typeof grecaptcha !== 'undefined' && grecaptcha.enterprise) {
//         // Google provides a .ready() callback to ensure the library is initialized
//         grecaptcha.enterprise.ready(() => {
//           resolve();
//         });
//         return;
//       }

//       if (Date.now() - start > timeout) {
//         reject(new Error('reCAPTCHA Enterprise failed to initialize.'));
//         return;
//       }

//       setTimeout(check, 100);
//     };

//     check();
//   });
// }

// /**
//  * Pre-bootstrap security gate
//  */
// (async () => {
//   try {

//     await waitForGrecaptcha();
//     // reCAPTCHA still runs (can also mock this if needed)
//     const token = await grecaptcha.enterprise.execute(
//       '6LfN3UEsAAAAAJAC0wtLjWpeTDLRzho-9U6s8737',
//       { action: 'LOGIN' }
//     );

//     // const result = USE_MOCK_ACCESS_API
//     //   ? await mockVerifyAccess()
//     //   : await realVerifyAccess(token);

//     const result = await realVerifyAccess(token);
//     if (!result.allow) {
//       renderAccessDenied();
//       return;
//     }

//     bootstrapAngularApp();
//   } catch (err) {
//     console.error(err);
//     renderAccessDenied();
//   }
// })();
